<div class="navigation-wrapper" *ngIf="slidesArray.length > 1" >
  <div class="keen-slider keen-slider--vertical" #sliderRef [hidden]="hideSlider" >
      <div *ngFor="let sl of slidesArray" class="keen-slider__slide number-slide{{sl.number + 1}}" >

        <div class="slide-image-container" *ngIf="shadow">
          <image [imageLink]="sl.image" class="slide-image-shadow" [ngStyle]="imageStyle"></image>
        </div>
        <img *ngIf="!shadow" src="{{sl.image}}" class="slide-image"  [ngStyle]="imageStyle">
      </div>
  </div>
  <svg *ngIf="slidesArray.length > 1"
    [ngClass]="
      'arrow arrow--left ' + (currentSlide === 0 ? 'arrow--disabled' : '')
    "
    (click)="slider.prev()"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
    />
  </svg>
  <svg
    *ngIf="slider && slidesArray.length > 1"
    [ngClass]="
      'arrow arrow--right ' +
      (slider.details().size - 1 === currentSlide ? 'arrow--disabled' : '')
    "
    (click)="slider.next()"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"/>
  </svg>
</div>
<div class="dots" *ngIf="slidesArray.length > 1">
  <button
    (click)="slider.moveToSlideRelative(i)"
    *ngFor="let slide of dotHelper; let i = index"
    [class]="'dot ' + (i === currentSlide ? 'active' : '')"
  ></button>

</div>
